// extracted by mini-css-extract-plugin
export default {"cardContainer":"exectuted-trigger-card_cardContainer__L7NP3","text01":"exectuted-trigger-card_text01__j7xqd","text02":"exectuted-trigger-card_text02__HH9LL"};